// GenerateQuote.jsx
import QuotesModel from "../models/QuotesModel";

const GenerateQuote = () => {
  const quotes = QuotesModel.getQuotes(); // Assume this function returns an array of strings
  const randomIndex = Math.floor(Math.random() * quotes.length);
  return quotes[randomIndex]; // Directly return the string quote
};

export default GenerateQuote;
